/*
 * Used for select when creating / updating gear.
 */
export const getYearData = () => {
  const currentYear = new Date().getFullYear();
  const yearData = [];
  for (let i = 1990; i <= currentYear; i++) {
    yearData.push({
      id: i,
      value: String(i),
    })
  }
  return yearData;
};



// WEBPACK FOOTER //
// ./src/Components/Requests/Add/AddExports/getYearData.jsx